// Stormberg Orthodontics (La Mesa CA) - single office.
// Backend: bondLocations.ts STORMBERG_LA_MESA (brandId "stormberg", catalog 85ae827e,
// Edge loc 1, procedure 220, DB 341). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 341). English-only.
import type { BrandConfig } from "./types";

export const stormberg: BrandConfig = {
  slug: "stormberg",
  brandId: "stormberg",
  brandName: "Stormberg Orthodontics",
  logo: "https://orthosandiego.com/wp-content/uploads/2023/04/Stormberg-Logo-2-Color_HORZ-01.png",
  phone: "(619) 462-4462",
  phoneHref: "tel:+16194624462",
  theme: { primary: "#38557C", primaryDark: "#24384F" }, // scoured 2026-07-14 orthosandiego.com (navy; sky-blue #2895CE is the lighter accent)
  locales: ["en"],
  locations: {
    STORMBERG_LA_MESA: {
      id: "STORMBERG_LA_MESA",
      name: "La Mesa",
      addressLines: ["4333 Palm Ave.", "La Mesa, CA 91941"],
      mapsUrl: "https://maps.google.com/?q=4333+Palm+Ave+La+Mesa+CA+91941",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { LA_MESA: "STORMBERG_LA_MESA", STORMBERG: "STORMBERG_LA_MESA" },
};
